// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IntegrationsCategoriesSelect_wrapper__hZlYa","dropdown":"IntegrationsCategoriesSelect_dropdown__DfKm6","icon":"IntegrationsCategoriesSelect_icon__vOIYr"};